import { Link } from "react-router-dom"
import logo from "../images/logo.svg"

export default function Logo() {
  return (
    <>
      <div>
        <Link to="/">
          <img src={logo} alt="BeBrokers" title="BeBrokers" className="w-40" />
        </Link>
      </div>
    </>
  )
}
